import axiosInstance from "../utils/authUtils";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class HotelAdminService {
  static gethotelList(item) {
  
      let api = '';
      if(item?.id){
         api= `${API_BASE_URL}${API_PATHS.getHotels}?id=${item?.id}`
      } else{
      api = `${API_BASE_URL}${API_PATHS.getHotels}?limit=${item?.limit}`;
      }
      return axiosInstance
          .get(api)
          
  }

  
static addHotels(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.addHotels}`;
    return axiosInstance
        .post(api,item)
        
}
static editHotels(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editHotels}`;
    return axiosInstance
        .put(api,item)
        
}

  
}

export default HotelAdminService;